import { Linkedin, Twitter } from 'lucide-react';
import { LogPulseLogo } from './LogPulseLogo';
import { LocalizedAnchor } from './LocalizedLink';
import { useT } from '@/i18n/provider';

export function LandingFooter() {
  const t = useT();

  const links = [
    {
      title: t('footer.product'),
      items: [
        { label: t('footer.features'), href: '/#features' },
        { label: t('footer.aiSearch'), href: '/ai-log-search' },
        { label: t('footer.fleet'), href: '/agents' },
        { label: t('footer.pricing'), href: '/#pricing' },
        { label: t('footer.docs'), href: '/docs' },
        { label: 'Changelog', href: '/changelog' },
        { label: 'Compare', href: '/compare' },
      ],
    },
    {
      title: t('footer.company'),
      items: [
        { label: 'Engineering Blog', href: '/blog' },
        { label: 'Join the Community', href: '/community' },
        { label: t('footer.contact'), href: '/contact' },
        { label: 'Security', href: '/security' },
        { label: t('footer.architecture'), href: '/architecture' },
        { label: t('footer.status'), href: '/status' },
      ],
    },
    {
      title: t('footer.legal'),
      items: [
        { label: t('footer.privacy'), href: '/privacy' },
        { label: t('footer.terms'), href: '/terms' },
        { label: t('footer.cookies'), href: '/cookies' },
        { label: t('footer.imprint'), href: '/imprint' },
      ],
    },
  ];

  return (
    <footer className="bg-gray-950 text-gray-400 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5">
              <LogPulseLogo className="h-7 w-7" />
              <span className="text-lg font-bold text-white">LogPulse</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed max-w-xs">
              {t('footer.tagline')}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="https://x.com/logpulse_io"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors"
                aria-label="LogPulse on X"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="https://linkedin.com/company/logpulse"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors"
                aria-label="LogPulse on LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {links.map((group) => (
            <div key={group.title}>
              <p className="text-sm font-semibold text-white mb-4">
                {group.title}
              </p>
              <ul className="space-y-2.5">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <LocalizedAnchor
                      href={item.href}
                      className="text-sm hover:text-white transition-colors"
                    >
                      {item.label}
                    </LocalizedAnchor>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-sm text-center">
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
}
